export default __webpack_public_path__ + "static/media/wts.bfa5da95.png";